import React, { useState } from 'react';
import TemplateSelectionStep from './TemplateSelectionStep';
import ExperimentCreationStep from './ExperimentCreationStep';

const TwoStepExperimentDialog = ({
  open,
  onClose,
  onSubmit,
  selectedTemplateId = null,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleTemplateSelected = template => {
    setSelectedTemplate(template);
    setCurrentStep(2);
  };

  const handleBackToTemplateSelection = () => {
    setCurrentStep(1);
    setSelectedTemplate(null);
  };

  const handleExperimentCreated = experimentData => {
    onSubmit(experimentData);
    // Reset state
    setCurrentStep(1);
    setSelectedTemplate(null);
  };

  const handleClose = () => {
    setCurrentStep(1);
    setSelectedTemplate(null);
    onClose();
  };

  return (
    <>
      <TemplateSelectionStep
        open={open && currentStep === 1}
        onClose={handleClose}
        onTemplateSelected={handleTemplateSelected}
        selectedTemplateId={selectedTemplateId}
      />

      <ExperimentCreationStep
        open={open && currentStep === 2}
        onClose={handleClose}
        onSubmit={handleExperimentCreated}
        selectedTemplate={selectedTemplate}
        onBack={handleBackToTemplateSelection}
      />
    </>
  );
};

export default TwoStepExperimentDialog;
